var map = {
	"./icons/back.svg": 85,
	"./icons/bell.svg": 86,
	"./icons/company.svg": 87,
	"./icons/delete.svg": 88,
	"./icons/email-read.svg": 89,
	"./icons/email-unread.svg": 90,
	"./icons/inbox.svg": 91,
	"./icons/star-fill.svg": 92,
	"./icons/star.svg": 93,
	"./icons/trash.svg": 94,
	"./images/automation.png": 95,
	"./images/clock.png": 96,
	"./images/crm.png": 97,
	"./images/digital-engagment.png": 98,
	"./images/e-commerce.png": 99,
	"./images/image-1.png": 100,
	"./images/image-2.png": 101,
	"./images/image-3.png": 102,
	"./images/image-4.png": 103,
	"./images/integrated-database.png": 104,
	"./images/interaction.png": 105,
	"./images/laptop-mockup.png": 106,
	"./images/loading.svg": 107,
	"./images/mobile-apps.png": 108,
	"./images/multi-point.png": 109,
	"./images/multitier-membership.png": 110,
	"./images/pipeline.png": 111,
	"./images/point-exchange.png": 112,
	"./images/point-formula.png": 113,
	"./images/realtime-report.png": 114,
	"./images/textarea-line.png": 115,
	"./images/web-apps.png": 116,
	"./logo/loyalid-blue.svg": 117,
	"./logo/loyalid.svg": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;